export default {
  props: {
    rate: {
      type: Number,
      default: undefined
    },
    clickable: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      starsObject: ['full', 'full', 'full', 'half', 'empty'],
      calculating: false,
      rateValue: 0
    };
  },
  watch: {
    rate: function() {
      this.calculateFillings();
    }
  },
  methods: {
    calculateFillings: function() {
      this.calculating = true;
      const rate = this.clickable ? (Math.round(this.rate * 2) / 2).toFixed(1) || this.rateValue.toString() : (Math.round(this.rate * 2) / 2).toFixed(1);
      const indexFull = Number.parseFloat(rate.split('.')[0]);
      const hasHalf = rate.split('.')[1] === '5';
      let index = 0;

      this.starsObject.forEach((x) => {
        if (index <= indexFull - 1) {
          this.starsObject[index] = 'full';
        } else if (index === indexFull) {
          this.starsObject[index] = hasHalf ? 'half' : 'empty';
        } else {
          this.starsObject[index] = 'empty';
        }
        index++;
      });
      this.calculating = false;
    },
    doRate: function(index) {
      if (this.clickable) {
        this.rateValue = index + 1;
        this.$emit('change', this.rateValue);
        this.calculateFillings();
      }
    }
  },
  mounted() {
    this.calculateFillings();
  }
};